import { RxDisplayStatus } from '~/constants/rxStatusChip'
import {
  isRxDisplayStatusIn,
  RX_DISPLAY_DECLINED_STATUSES,
} from '~/utils/rxStatusChipUtils'

/** Display statuses where the timeline Rx card header should not navigate and Chewy order banners are hidden. */
const RX_CARD_HEADER_SUPPRESSED_DISPLAY_STATUSES = new Set<RxDisplayStatus>([
  RxDisplayStatus.CANCELED,
  RxDisplayStatus.PENDING_VET_APPROVAL,
  ...RX_DISPLAY_DECLINED_STATUSES,
])

export function isRxCardHeaderSuppressedRxDisplayStatus(
  status: RxDisplayStatus | null,
): boolean {
  return isRxDisplayStatusIn(status, RX_CARD_HEADER_SUPPRESSED_DISPLAY_STATUSES)
}
